import {AfterViewInit, Component, ElementRef, Inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {FormControl, Validators} from '@angular/forms';
import {DocumentTypeService} from '../../services/document-type.service';
import {DocumentType} from '../../model/Entities/DocumentType';
import {Router} from '@angular/router';
import {Contract} from '../../model/Entities/Contract';
import {SnackService} from '../../services/snack.service';
import {DocumentService} from '../../services/document.service';

@Component({
    selector: 'document-delete-dialog',
    templateUrl: './document-delete.dialog.component.html',
    styleUrls: ['./document-delete.dialog.component.scss']
})
export class DocumentDeleteDialogComponent implements AfterViewInit {
    document: any;


    constructor(public dialog: MatDialogRef<DocumentDeleteDialogComponent>,
                private router: Router,
                private documentService: DocumentService,
                private snackService: SnackService,
                @Inject(MAT_DIALOG_DATA) public data: any) {

        this.document = data.document;

    }

    ngAfterViewInit(): void {
    }

    delete() {
        this.documentService.delete(this.document.id).subscribe(() => {
            this.snackService.showSuccess('Dokument byl úspěšně smazán.');
            this.dialog.close(true);
        }, function () {
            this.snackService.showWarn('Dokument se nepodařilo smazat.');
        });

    }
}



// WEBPACK FOOTER //
// /app/src/DocumentsModule/DocumentDeleteDialogComponent/document-delete.dialog.component.ts